import React, { type FC } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import errorImage from '@atlassian/jira-servicedesk-common/src/utils/assets/error.svg';
import MessageCallToAction from '../message-call-to-action/view.tsx';
import messages from './messages.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Props = Record<any, any>;

export const AppLinkErrorPanel: FC<Props> = () => {
	const { formatMessage } = useIntl();
	return (
		<MessageCallToAction
			imageUrl={errorImage}
			header={formatMessage(messages.applinkErrorHeader)}
			description={formatMessage(messages.applinkErrorMessage)}
		/>
	);
};

export default AppLinkErrorPanel;
